import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from '../../services/auth.service';
import {
  AddPagePayload,
  CheckDomainValidityResponse,
  Company,
  CompanyRegister,
  DomainPayload,
  DomainResponse,
  RequestCompanyDatatable,
} from '../_models/company.model';
import { Datatable, RequestDatatable } from '../_models/report.models';
import { CopyAppPayload } from '../_models/settings.models';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  private baseURL = '/api';
  private ADD_PAYMENT_METHOD_URL = '/payment/addPaymentMethod';
  private GET_COMPANY_URL = '/company';
  private UPDATE_COMPANY = '/updatecompany';
  private DELETE_COMPANY = '/deletecompany';
  private CANCEL_COMPANY_SUBSCRIPTION = '/cancelsubscription';
  private GET_COMPANIES_URL = '/company/getcompanies';
  private GET_COMPANIES_DATATABLE_URL = '/company/getdatatable';
  private GET_COMPANY_USERS_DATATABLE_URL = '/company/getusersdatatable';
  private GET_CROSS_DOMAIN_COMPANIES = '/application/crossdomaincompanies';
  private CHECK_DOMAIN = '/company/checkdomainavailability';
  private REQUEST_DOMAIN = '/company/requestdomain';
  private CHECK_DOMAIN_STATUS = '/company/checkstatus';

  constructor(private http: HttpClient) {}

  public get checkDomainUrl() {
    return `${environment.apiUrl}${this.baseURL}${this.CHECK_DOMAIN}`;
  }
  public get requestDomainUrl() {
    return `${environment.apiUrl}${this.baseURL}${this.REQUEST_DOMAIN}`;
  }
  public get checkDomainStatusurl() {
    return `${environment.apiUrl}${this.baseURL}${this.CHECK_DOMAIN_STATUS}`;
  }

  /**
   * Get companies
   */
  getCompanies = (): Observable<Array<Company>> =>
    this.http.get<Array<Company>>(
      `${environment.apiUrl}${this.baseURL}${this.GET_COMPANIES_URL}`,
      {}
    );

  /**
   * Get company details
   */
  getCompany = (id: number): Observable<Company> =>
    this.http.get<Company>(
      `${environment.apiUrl}${this.baseURL}${this.GET_COMPANY_URL}?id=${id}`,
      {}
    );

    /**
   * Get Cross Domain Companies
   */
    getCrossDomainCompanies = (payload: CopyAppPayload): Observable<any> =>
    this.http.post(`${environment.apiUrl}${this.baseURL}${this.GET_CROSS_DOMAIN_COMPANIES}`, payload);

  /**
   * Get companies datatable
   */
  getCompaniesDatatable = (
    payload: RequestCompanyDatatable
  ): Observable<Datatable> =>
    this.http.post<Datatable>(
      `${environment.apiUrl}${this.baseURL}${this.GET_COMPANIES_DATATABLE_URL}`,
      payload,
      {}
    );

  /**
   * Get company users datatable
   */
  getCompanyUsersDatatable = (
    payload: RequestCompanyDatatable
  ): Observable<Datatable> =>
    this.http.post<Datatable>(
      `${environment.apiUrl}${this.baseURL}${this.GET_COMPANY_USERS_DATATABLE_URL}`,
      payload,
      {}
    );

  /**
   * Cancel company subscription
   */
  cancelCompanySubscriptoin = (companyId: number): Observable<Company> =>
    this.http.get<Company>(
      `${environment.apiUrl}${this.baseURL}${this.GET_COMPANY_URL}${this.CANCEL_COMPANY_SUBSCRIPTION}?id=${companyId}`,
      {}
    );

  /**
   * Delete Company
   */
  deleteCompany = (companyId: number): Observable<void> =>
    this.http.delete<void>(
      `${environment.apiUrl}${this.baseURL}${this.GET_COMPANY_URL}${this.DELETE_COMPANY}?id=${companyId}`,
      {}
    );

  /**

  /**
   * Update company
   */
  updateCompany = (payload: CompanyRegister): Observable<any> =>
    this.http.put<any>(
      `${environment.apiUrl}${this.baseURL}${this.GET_COMPANY_URL}${this.UPDATE_COMPANY}`,
      payload,
      {}
    );

  /**
   * Add payment method
   */
  addPaymentMethod = (
    customerId: string,
    paymentMethodId: string,
    isDefaultMethod: boolean
  ): Observable<any> =>
    this.http.get<any>(
      `${environment.apiUrl}${this.baseURL}${this.ADD_PAYMENT_METHOD_URL}?paymentMethodId=${paymentMethodId}&customerId=${customerId}&isDefaultMethod=${isDefaultMethod}`,
      {}
    );


  /**
   * Check Domain Validity
   */
  checkDomainValidity=(payload:DomainPayload):Observable<CheckDomainValidityResponse> =>
      this.http.post<CheckDomainValidityResponse>(`${this.checkDomainUrl}`,payload);

  /**
   * Check Domain Validity
   */
  requestDomain = (payload:DomainPayload):Observable<DomainResponse> =>
      this.http.post<DomainResponse>(`${this.requestDomainUrl}`,payload);

  /**
   * Check Domain Validity
   */
  checkDomainStatus=(payload:DomainPayload):Observable<DomainResponse> =>
      this.http.get<DomainResponse>(`${this.checkDomainStatusurl}?id=${payload.Key}`);

  addPage = (payload: AddPagePayload): Observable<any> =>
  this.http.post<any>(`${environment.apiUrl}${this.baseURL}/companylandingpage`, payload, {});
  
  /**
   *
   * Updatea a Page
   */

  updatePage = (payload: AddPagePayload): Observable<any> =>
    this.http.put<any>(`${environment.apiUrl}${this.baseURL}/companylandingpage`, payload, {});

  /**
   * Delete a Page
   */

  deletePage = (companyId: string): Observable<any> =>
    this.http.delete<any>(`${environment.apiUrl}${this.baseURL}/companylandingpage?id=${companyId}`, {});

  toggleLandingPage = (payload: any): Observable<any> =>
    this.http.put<any>(`${environment.apiUrl}${this.baseURL}/company/togglelandingpage`, payload, {});
}
